import React from 'react';
import PropTypes from 'prop-types';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import { useTracking } from 'react-tracking';

import './FormSiteList.css';
import HelloSign from 'hellosign-embedded';

export default function FormSiteList({
  toggle, setEmbedParams, assessments, hsClient, messageId,
}) {
  // eslint-disable-next-line no-unused-vars

  const getFormComponents = () => assessments.sort((a) => {
    switch (a.assessmentType) {
      case 'registration':
        return -1;
      case 'document':
        return 1;
      default:
        return 0;
    }
  }).map((formInfo) => {
    if (formInfo.assessmentType === 'document') {
      return (
        <DocumentListItem
          document={formInfo}
          hsClient={hsClient}
          key={formInfo.id}
          messageId={messageId}
        />
      );
    }
    return (
      <ListItem
        form={formInfo}
        toggle={toggle}
        setEmbedParams={setEmbedParams}
        key={formInfo.id}
        messageId={messageId}
      />
    );
  });

  return (
    <ListGroup className="bootstrap-override">
      {
        getFormComponents().map((forms) => forms)
      }
    </ListGroup>
  );
}

FormSiteList.propTypes = {
  toggle: PropTypes.func.isRequired,
  setEmbedParams: PropTypes.func.isRequired,
  assessments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    complete: PropTypes.bool,
    name: PropTypes.string,
    description: PropTypes.string,
    key: PropTypes.string,
    formID: PropTypes.string,
    prePopulate: PropTypes.objectOf(PropTypes.string),
  })).isRequired,
  hsClient: PropTypes.instanceOf(HelloSign).isRequired,
  messageId: PropTypes.string,
};

FormSiteList.defaultProps = {
  messageId: null,
};

function ListItem({
  form, toggle, setEmbedParams, messageId,
}) {
  const { trackEvent } = useTracking();

  function handleClick() {
    setEmbedParams({
      key: form.key,
      id: form.formID,
      prePopulate: form.prePopulate,
    });
    trackEvent({
      messageId, event: `${form.name} started`, eventDetails: { formId: form.id }, result: 'success',
    });
    toggle();
  }

  return (
    <ListGroup.Item
      disabled={form.complete}
      onClick={() => handleClick()}
      action
      variant="primary"
      key={form.id}
      className="bootstrap-override"
    >
      <Row>
        <Col>
          <div className="ms-2 me-auto">
            <div className="fw-bold">{form.name}</div>
            {form.description}
          </div>
        </Col>
        {/* show Complete badge if complete === true */}
        {form.complete
            && (
            <Col className="d-flex" xs="auto">
              <Badge className="align-self-end ms-auto" pill bg="success">Complete</Badge>
            </Col>
            )}
      </Row>
    </ListGroup.Item>
  );
}

ListItem.propTypes = {
  form: PropTypes.shape({
    id: PropTypes.string,
    complete: PropTypes.bool,
    name: PropTypes.string,
    description: PropTypes.string,
    key: PropTypes.string,
    formID: PropTypes.string,
    prePopulate: PropTypes.objectOf(PropTypes.string),
    assessmentType: PropTypes.string,
  }).isRequired,
  toggle: PropTypes.func.isRequired,
  setEmbedParams: PropTypes.func.isRequired,
  messageId: PropTypes.string.isRequired,
};

const DocumentListItem = ({
  document, hsClient, messageId,
}) => {
  const { trackEvent } = useTracking();

  const handleClick = () => {
    if (messageId) {
      trackEvent({
        messageId, event: `${document.name} started`, eventDetails: { documentId: document.id }, result: 'success',
      });
    }
    console.log(document.signatureUrl);
    hsClient.open(document.signatureUrl, {
      skipDomainVerification: true,
      testMode: true,
    });
  };

  return (
    <ListGroup.Item
      disabled={document.complete}
      onClick={() => handleClick()}
      action
      variant="primary"
      key={document.id}
      className="bootstrap-override"
    >
      <Row>
        <Col>
          <div className="ms-2 me-auto">
            <div className="fw-bold">{document.name}</div>
            {document.description}
          </div>
        </Col>
        {/* show Complete badge if complete === true */}
        {document.complete
            && (
            <Col className="d-flex" xs="auto">
              <Badge className="align-self-end ms-auto" pill bg="success">Complete</Badge>
            </Col>
            )}
      </Row>
    </ListGroup.Item>
  );
};

DocumentListItem.propTypes = {
  document: PropTypes.shape({
    id: PropTypes.string,
    complete: PropTypes.bool,
    name: PropTypes.string,
    description: PropTypes.string,
    key: PropTypes.string,
    signatureId: PropTypes.string,
    signatureUrl: PropTypes.string,
    assessmentType: PropTypes.string,
  }).isRequired,
  hsClient: PropTypes.instanceOf(HelloSign).isRequired,
  messageId: PropTypes.string,
};

DocumentListItem.defaultProps = {
  messageId: '',
};
